import { SaveButton } from "../../../components/SaveButton";


export default {
    init(){
        this.initModal();
        this.getFormItems();
        this.modifierMenu();
    },
    initModal() {
        let _this = this;
        $('.attributes-list__table-controls-button-add, .attributes-list__table-controls-row-item').click(function (e) {
            let action = $(this).data('action');
            if (action == 'delete'){
                return true;
            }
            let attributeId = $(this).data('attribute-id');
            e.preventDefault();
            let ajaxData = {
                type: 'GET',
                url: '/services-management/attributes/get-form',
                success: function (response) {
                    $('#form-container').html(response);
                    $('#attributes-modal').modal('show');
                    _this.attributeTypeChange();
                    _this.attributeAmountChange();
                    _this.addModifier();
                    _this.deleteModifierRow();
                    _this.sendAttributeForm();
                    _this.changeAttributeSort();
                    _this.sortAvailable();
                    _this.amountMask();
                    //_this.actualizeSubscriptionValues();
                }
            };
            if (attributeId){
                ajaxData.data = {
                    id: attributeId
                }
            }
            $.ajax(ajaxData);
        });
    },
    attributeTypeChange(){
        let _this = this;
        let multipleInput = $('#multiple_modifiers');
        let attributesAmountInput = $('#attributes-amount-input');
        $('#attributes-type').change(function(){
            _this.returnSubscriptionVariants();
            _this.resetModifierRows();
            _this.showSelectHint($(this));
            let attributeType = $(this).val();
            if (attributeType != 'regular'){
                attributesAmountInput.removeClass('d-none');
                multipleInput.addClass('disabled');
                multipleInput.attr('checked', true);
                return true;
            }
            multipleInput.removeClass('disabled');
            attributesAmountInput.addClass('d-none');
        });
    },
    resetModifierRows(){
        let attributesRowsWrapper = $('#attributes-rows');
        $('#attributes-submit-form').attr('disabled', true);
        attributesRowsWrapper.html('');
    },
    deleteModifierRow() {
        const modifiersCount = () => {
            if ($('.attributes-modal__delete-modifier').length > 1) {
                $('.attributes-modal__delete-modifier').removeClass('d-none').removeClass('disabled');
            } else {
                $('.attributes-modal__delete-modifier').addClass('d-none').addClass('disabled');
            }

            this.sortAvailable();
        }

        $('.attributes-modal__delete-modifier:not(.disabled)').click(function(){
            let incrementInput = $('input[name="increment"]');
            let variantsInput = $('input[name="subscription_variants"]');
            incrementInput.val(parseInt(incrementInput.val()) - 1);
            let modifierId = $(this).data('id');
            let attributesRowsWrapper = $('#attributes-rows');
            let chosenVariantElement = $('#modifier-id-' + modifierId + ' .attributes-edit-title');
            let chosenVariant = chosenVariantElement.val();
            let variants = JSON.parse(variantsInput.val());
            if ($('option:selected', chosenVariantElement).text() !=='') {
                variants[chosenVariant] = $('option:selected', chosenVariantElement).text();
            }
            variantsInput.val(JSON.stringify(variants));
            $('#modifier-id-' + modifierId, attributesRowsWrapper).remove();
            modifiersCount();
        });

        modifiersCount();
    },
    returnSubscriptionVariants(){
        let variantsInput = $('input[name="subscription_variants"]');
        let variantsElements = $('select.custom-select.attributes-edit-title').toArray();
        console.log(variantsElements);
        if (variantsElements.length > 0) {
            let variants = JSON.parse(variantsInput.val());
            variantsElements.forEach(element => {
                if (element.value != '') {
                    console.log('element value', element.value);
                    let chosenVariant = $(element).val();
                    variants[chosenVariant] = $('option:selected', $(element)).text();
                }
            });
            variantsInput.val(JSON.stringify(variants));
        }

        console.log(variantsElements, variantsInput);
        $('input[name="increment"]').val(0);
    },
    attributeAmountChange(){
        let _this = this;
        $('#attributes-amount').change(function(){
            _this.returnSubscriptionVariants();
            _this.showSelectHint($(this));
            _this.resetModifierRows();
        });
    },
    showSelectHint(jqElem){
        let hintName = $('option:selected', jqElem).val();
        let hints = jqElem.parent().find('.attributes-modal__input-description');
        hints.addClass('d-none');
        $('div[data-hint="' + hintName + '"]').removeClass('d-none');
    },
    addModifier(){
        let _this = this;
        let attributesForm = document.getElementById('attributes-form');
        let attributesRowsWrapper = $('#attributes-rows');

        $('.form-row__add-modifier-button').click(function(){
            let formData = new FormData(attributesForm);
            let variantsInput = $('input[name="subscription_variants"]');
            let increment = formData.get('increment');
            let rowRequest = {
                increment,
                amount: formData.get('amount'),
                type: formData.get('type'),
                subscription_variants: formData.get('subscription_variants'),
            }
            $.ajax({
                type: 'GET',
                url: '/services-management/attributes/get-form-row',
                data: rowRequest,
                success: function (response) {
                    $('input[name="increment"]').val(++increment);
                    attributesRowsWrapper.append(response);
                    let chosenVariantElement = $('#modifier-id-' + increment + ' .attributes-edit-title');
                    let chosenVariant = chosenVariantElement.val();
                    let variants = JSON.parse(formData.get('subscription_variants'));
                    delete variants[chosenVariant];
                    variantsInput.val(JSON.stringify(variants));
                    _this.deleteModifierRow();
                    $('#attributes-submit-form').removeAttr('disabled');
                    _this.amountMask('#modifier-id-' + increment);
                    //_this.actualizeSubscriptionValues();
                    //_this.sortAvailable();
                },
                error: function (response) {
                    console.log(response);
                }
            });
        });
    },
    sendAttributeForm(){
        let $this = this;
        $('#attributes-submit-form').click(function(){
            let formId = $(this).attr('form');
            this.SaveBtn = new SaveButton();
            let result = $this.formValidation('attributes-form');
            if (result) {
                $.ajax({
                    type: 'POST',
                    url: '/services-management/attributes/save-attribute',
                    data: $('#attributes-form').serialize(),
                    beforeSend: () =>{
                        this.SaveBtn.startLoading();
                    },
                    success: () => {
                        this.SaveBtn.stopLoading().then(
                            () => {
                                this.SaveBtn.showSuccess().then(
                                    function() {
                                        $('#attributes-modal').modal('hide');
                                        location.reload(true);
                                    }
                                )
                            }
                        );
                    },
                    error: (response) => {
                        this.SaveBtn.showError().then(
                            () => {
                                this.SaveBtn.stopLoading();
                                //window.location.reload(true);
                            }
                        );

                    }
                });
            }
        });
    },
    getFormItems() {
        $('.attributes-list__table-apply-service-link').click(function (e) {
            e.preventDefault();
            $.ajax({
                type: 'GET',
                url: '/modifier_get_form_items',
                data: ({
                    id: $(this).data('id'),
                }),
                success: function (response) {
                    $('#form-container').html(response);
                    $('#modifier-modal').modal('show');
                }
            })
        });
    },
    changeAttributeSort() {

        const sortCallback = this.sortAvailable;

        $('.modal').on('click', '.product-modal__sort-button', function() {
            if (this.hasAttribute('disabled')) return;

            let sortDirection = $(this).data('sort-direction');
            let parentRow = $(this).parents('.attributes-edit-row');
            let targetRow;
            if (sortDirection == 'down') {
                targetRow = $('#modifier-id-' + (parentRow.data('sort') + 1));
            }
            if (sortDirection == 'up'){
                targetRow = $('#modifier-id-' + (parentRow.data('sort') - 1));
            }
            if (targetRow === undefined){
                console.log('undefined');
                return;
            }

            let target_html = targetRow.html();
            targetRow.html(parentRow.html());
            parentRow.html(target_html);

            // let targetTitle = targetRow.find('.attributes-edit-title').val();
            // let targetValue = targetRow.find('.attributes-edit-value').val();
            // targetRow.find('.attributes-edit-title').val(parentRow.find('.attributes-edit-title').val());
            // targetRow.find('.attributes-edit-value').val(parentRow.find('.attributes-edit-value').val());
            // parentRow.find('.attributes-edit-title').val(targetTitle);
            // parentRow.find('.attributes-edit-value').val(targetValue);

            sortCallback();
        });
    },

    sortAvailable() {
        const rows = $('#attributes-rows .form-group').not('.new');
        if (rows.length == 1) $('.product-modal__sort-button').prop("disabled", true).addClass('sort_disabled');
        else {
            rows.each(function (index) {
                if (index == 0) {
                    $(this).find('.product-modal__sort-button[data-sort-direction=up]').prop("disabled", true).addClass('sort_disabled');
                    $(this).find('.product-modal__sort-button[data-sort-direction=down]').prop("disabled", false).removeClass('sort_disabled');
                } else if (index == rows.length - 1) {
                    $(this).find('.product-modal__sort-button[data-sort-direction=up]').prop("disabled", false).removeClass('sort_disabled');
                    $(this).find('.product-modal__sort-button[data-sort-direction=down]').prop("disabled", true).addClass('sort_disabled');
                } else {
                    $(this).find('.product-modal__sort-button').prop("disabled", false).removeClass('sort_disabled');
                }
            });
        }
    },

    formValidation(formId){
        if ($(`#${formId}`).length>0) {
            let flag = true;
            const values = $(`#${formId}`).find('.attributes-edit-value').toArray();
            values.forEach(element => {
                if ($(element).val() == '') {
                    $(element).css('border-color', 'red');
                    flag = false;
                }else{
                    $(element).css('border-color', '');
                }
            });
            const titles = $(`#${formId}`).find('.attributes-edit-title').toArray();
            titles.forEach(element => {
                if ($(element).val() == '') {
                    $(element).css('border-color', 'red');
                    flag = false;
                }else{
                    $(element).css('border-color', '');
                }
            });
            if ($('#attributes-title').val()=='') {
                $('#attributes-title').css('border-color', 'red');
                flag = false;
            }else{
                $('#attributes-title').css('border-color', '');
            }
            return flag;
        }else{
            return false;
        }
    },

    actualizeSubscriptionValues(){
        if ($('#attributes-type').val() == 'subscription') {
            const SubSelects = $('select.attributes-edit-title option:not(:selected)').toArray();
            let variantsInput = $('input[name="subscription_variants"]');
            let variants = JSON.parse(variantsInput.val());
            SubSelects.forEach(element => {
                if (typeof(variants[element.value]) == 'undefined' || typeof(variants[element.value]) == null) {
                    $(element).remove();
                }else{
                }
            })
        }
    },

    amountMask(additional=''){
        Inputmask("[-]{0,1}9{*}[.]9{0,2}", { placeholder: "-", greedy: false }).mask(`${additional} .attributes-edit-value`);
    },

    modifierMenu(){
        $('body').off('click', '.modifier-menu-btn')
        .on('click', '.modifier-menu-btn', function(e) {
            const parentRow = $(this).parents('.form-group');

            if ($(parentRow).find('.modifier-menu-modal').hasClass('opened')) {
                $(parentRow).find('.modifier-menu-modal').removeClass('opened');
            } else {
                $('.modifier-menu-modal').removeClass('opened');
                $(parentRow).find('.modifier-menu-modal').addClass('opened');
            }
            let posX = $(this).position().left - ($('.modifier-menu-modal').width() + 10);
            let posY = $(this).position().top + 10;
            $('.modifier-menu-modal').css({left: posX, top: posY});
        });
        $('body').off('click', '.modifier-menu-modal .close-elem')
        .on('click', '.modifier-menu-modal .close-elem', function() {
            $(this).parents('.modifier-menu-modal').removeClass('opened');
        });
    }
}
